import { css } from 'styled-components';
import { cubicEaseOut } from './animate';
import { brand } from './brand';
import fonts from './fonts';
import { Device, from } from './media';
const headingStyles = css `
  color: currentColor;
  ${fonts.montserrat.extraBold};
  margin: 0 0 1em;
`;
export const h1 = css `
  ${headingStyles};
  font-size: 32px;
  line-height: 44px;

  @media ${from(Device.TabletSmall)} {
    font-size: 40px;
    line-height: 48px;
  }

  @media ${from(Device.TabletLarge)} {
    font-size: 40px;
    line-height: 52px;
  }

  @media ${from(Device.DesktopLarge)} {
    font-size: 44px;
    line-height: 60px;
  }
`;
export const h2 = css `
  ${headingStyles};
  font-size: 28px;
  line-height: 36px;

  @media ${from(Device.TabletSmall)} {
    font-size: 32px;
    line-height: 40px;
  }

  @media ${from(Device.TabletLarge)} {
    font-size: 36px;
    line-height: 48px;
  }

  @media ${from(Device.DesktopLarge)} {
    font-size: 40px;
    line-height: 56px;
  }
`;
export const h3 = css `
  ${headingStyles};
  font-size: 24px;
  line-height: 32px;

  @media ${from(Device.TabletSmall)} {
    font-size: 28px;
    line-height: 36px;
  }

  @media ${from(Device.TabletLarge)} {
    font-size: 32px;
    line-height: 42px;
  }

  @media ${from(Device.DesktopLarge)} {
    font-size: 32px;
    line-height: 42px;
  }
`;
export const h4 = css `
  ${headingStyles};
  font-size: 20px;
  line-height: 28px;

  @media ${from(Device.TabletSmall)} {
    font-size: 24px;
    line-height: 30px;
  }

  @media ${from(Device.TabletLarge)} {
    font-size: 28px;
    line-height: 36px;
  }

  @media ${from(Device.DesktopLarge)} {
    font-size: 28px;
    line-height: 36px;
  }
`;
export const h5 = css `
  ${headingStyles};
  font-size: 18px;
  line-height: 26px;

  @media ${from(Device.TabletSmall)} {
    font-size: 20px;
    line-height: 26px;
  }

  @media ${from(Device.TabletLarge)} {
    font-size: 24px;
    line-height: 32px;
  }

  @media ${from(Device.DesktopLarge)} {
    font-size: 24px;
    line-height: 32px;
  }
`;
export const h6 = css `
  ${headingStyles};
  font-size: 16px;
  line-height: 22px;

  @media ${from(Device.TabletSmall)} {
    font-size: 18px;
    line-height: 24px;
  }

  @media ${from(Device.TabletLarge)} {
    font-size: 18px;
    line-height: 24px;
  }

  @media ${from(Device.DesktopLarge)} {
    font-size: 20px;
    line-height: 28px;
  }
`;
const paragraphStyles = css `
  color: currentColor;
  ${fonts.montserrat.regular};
  margin: 0 0 1em;
`;
export const paragraphLarge = css `
  ${paragraphStyles};
  font-size: 15px;
  line-height: 28px;

  @media ${from(Device.TabletSmall)} {
    font-size: 16px;
    line-height: 30px;
  }

  @media ${from(Device.TabletLarge)} {
    font-size: 20px;
    line-height: 36px;
  }

  @media ${from(Device.DesktopLarge)} {
    font-size: 22px;
    line-height: 38px;
  }
`;
export const paragraph = css `
  ${paragraphStyles};
  font-size: 16px;
  line-height: 26px;

  @media ${from(Device.TabletSmall)} {
    font-size: 16px;
    line-height: 26px;
  }

  @media ${from(Device.TabletLarge)} {
    font-size: 18px;
    line-height: 30px;
  }

  @media ${from(Device.DesktopLarge)} {
    font-size: 18px;
    line-height: 34px;
  }
`;
export const paragraphSmall = css `
  ${paragraphStyles};
  font-size: 14px;
  line-height: 24px;

  @media ${from(Device.TabletSmall)} {
    font-size: 14px;
    line-height: 24px;
  }

  @media ${from(Device.TabletLarge)} {
    font-size: 16px;
    line-height: 26px;
  }

  @media ${from(Device.DesktopLarge)} {
    font-size: 16px;
    line-height: 26px;
  }
`;
export const paragraphMicro = css `
  ${paragraphStyles};
  font-size: 14px;
  line-height: 18px;
`;
export const quote = css `
  color: currentColor;
  ${fonts.montserrat.regularItalic};
  font-size: 18px;
  line-height: 32px;
  margin: 0 0 1em;

  @media ${from(Device.TabletSmall)} {
    font-size: 18px;
    line-height: 32px;
  }

  @media ${from(Device.TabletLarge)} {
    font-size: 22px;
    line-height: 38px;
  }

  @media ${from(Device.DesktopLarge)} {
    font-size: 24px;
    line-height: 40px;
  }
`;
export const link = css `
  display: inline-block;
  color: currentColor;
  text-decoration: underline;
  text-underline-position: under;
  transition: color 0.15s ${cubicEaseOut};

  &:focus {
    outline: none;
  }

  &:focus,
  &:hover {
    background-size: 100% 100%;
    color: ${brand.green.dark};
  }
`;
export const listStyles = css `
  ${paragraphStyles};
  font-size: 16px;
  line-height: 26px;

  @media ${from(Device.TabletSmall)} {
    font-size: 16px;
    line-height: 26px;
  }

  @media ${from(Device.TabletLarge)} {
    font-size: 18px;
    line-height: 30px;
  }

  @media ${from(Device.DesktopLarge)} {
    font-size: 18px;
    line-height: 34px;
  }
`;
export const table = css `
  background: ${brand.white};
  border-collapse: collapse;
  color: ${brand.black};
  margin-bottom: 1em;

  /* override fixed width inserted by RTE, and ensure the table scales to container */
  width: 100% !important;

  thead {
    tr {
      background: ${brand.green.tea};

      td,
      th {
        color: ${brand.black};
        ${fonts.montserrat.bold};
        font-size: 20px;
        line-height: 28px;
        padding: 25px 15px;
        text-align: left;

        &:first-child {
          padding-left: 30px;
        }

        @media ${from(Device.TabletLarge)} {
          font-size: 24px;
          line-height: 38px;
          text-align: center;
          vertical-align: middle;
          padding: 30px;
        }
      }
    }
  }

  tbody {
    tr {
      /* override fixed width and heights inserted by RTE */
      width: auto !important;
      height: auto !important;

      &:nth-child(even) {
        background: ${brand.lightGrey};
      }

      &:nth-child(odd) {
        background: ${brand.white};
      }

      th {
        color: ${brand.white};
        ${fonts.montserrat.extraBold};
        font-size: 18px;
        line-height: 22px;
        padding: 12px 16px;
        text-align: left;
      }

      td {
        ${fonts.montserrat.regular};
        font-size: 16px;
        line-height: 22px;
        padding: 10px 15px;
        text-align: left;

        /* override fixed width and heights inserted by RTE */
        width: auto !important;
        height: auto !important;

        &:first-child {
          padding-left: 30px;
        }

        @media ${from(Device.TabletLarge)} {
          font-size: 22px;
          line-height: 34px;
          padding: 25px 30px;
        }

        p {
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }
`;
export const contentStyles = css `
  h1,
  .h1-styles {
    ${h1}
  }

  h2,
  .h2-styles {
    ${h2}
  }

  h3,
  .h3-styles {
    ${h3}
  }

  h4,
  .h4-styles {
    ${h4}
  }

  h5,
  .h5-styles {
    ${h5}
  }

  h6,
  .h6-styles {
    ${h6}
  }

  p {
    ${paragraph}
  }

  p.large {
    ${paragraphLarge}
  }

  p.small {
    ${paragraphSmall}
  }

  a {
    ${link}
    display: inline;
  }

  span {
    display: inline;
  }

  ol,
  ul {
    ${listStyles}
  }

  ol {
    list-style: decimal;
    padding-left: 1.2em;
  }

  ul {
    list-style: disc;
    padding-left: 1.2em;
    list-style-position: inside;
  }

  ul.large {
    ${paragraphLarge}
    margin-bottom: 0;
  }

  hr {
    display: block;
    background: currentColor;
    border: 0;
    height: 4px;
    margin: 40px 0;
    padding: 0;
    width: 100%;

    @media ${from(Device.Tablet)} {
      margin: 80px 0;
    }
  }

  blockquote {
    color: currentcolor;
    font-family: ${fonts.montserrat.regular};
    margin: 0px 0px 1em;
    font-size: 18px;
    line-height: 26px;
    letter-spacing: -0.01em;
    position: relative;
    padding: 8px 0px 8px 20px;

    &:before {
      content: '';
      position: absolute;
      top: 0px;
      left: 0px;
      width: 4px;
      height: 100%;
      background-color: ${brand.green.dark};
    }
  }

  table {
    ${table};
  }

  .responsive-table {
    position: relative;
    overflow-x: auto;

    &.small-text {
      thead {
        td,
        th {
          font-size: 18px;
          line-height: 22px;
          padding: 22px 12px;

          @media ${from(Device.TabletLarge)} {
            padding: 22px;
            font-size: 20px;
            line-height: 28px;
          }
        }
      }

      tbody tr {
        td,
        th {
          padding: 8px 12px;
          font-size: 16px;
          line-height: 22px;

          @media ${from(Device.TabletLarge)} {
            font-size: 18px;
            line-height: 24px;
            padding: 20px;
          }
        }
      }
    }
  }

  .brand-black {
    color: ${brand.black};
  }

  .brand-white {
    color: ${brand.white};
  }

  .brand-accent {
    color: var(--accentColor);
  }

  .text-align-center {
    text-align: center;
  }

  .text-align-right {
    text-align: right;
  }

  /* Double selector to override class specificity */
  > *:first-child:first-child {
    margin-top: 0;
  }

  /* Double selector to override class specificity */
  > *:last-child:last-child {
    margin-bottom: 0;
  }
`;
